export const DEALS_FILTER_OPTIONS = [
	{ value: 'all', label: 'All Deals' },
	{ value: 'fmf', label: 'First Month Free' },
	{ value: 'additional', label: 'Additional Deals' },
];
